import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BusinessAds } from '@app/model/business-ads';
import { Paging } from '@app/model/paging';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class BusinessAdsService {
  API_BASE_PATH= environment.API_URL;

  constructor(
    private http: HttpClient,
  ) { }

  // Get by UUID
  getAllBusinessAds(paging: Paging): Observable<BusinessAds[]> {
    return this.http.get<BusinessAds[]>(`${this.API_BASE_PATH}business-ads`+ '?paging=' + paging);
  }

  // Get by UUID
  getBusinessAdsByUUId(UUID: any): Observable<BusinessAds> {
    return this.http.get<BusinessAds>(`${this.API_BASE_PATH}${UUID}/business-ads`);
  }

  // Get by UUID
  getTop8BusinessAds(): Observable<BusinessAds> {
    return this.http.get<BusinessAds>(`${this.API_BASE_PATH}business-top-ads`);
  }

  // Get by UUID
  getBusinessAdsByUUId_ID(UUID: any, Id: any): Observable<BusinessAds> {
    return this.http.get<BusinessAds>(`${this.API_BASE_PATH}${UUID}/business-ads${Id}`);
  }

  // Add by UUID, no ID
  addBusinessAdsByUUId(UUID: any, formData: FormData) {
    return this.http.post(`${this.API_BASE_PATH}${UUID}/business-ads`, formData);
  }
  
  // Update by UUID and data existing ID
  updateBusinessAdsByUUId(UUId: any, formData: FormData): Observable<BusinessAds> {
    return this.http.patch<BusinessAds>(`${this.API_BASE_PATH}${UUId}/business-ads`, formData);
  }

  // Delete by UUID and ID
  deleteBusinessAdsByUUID_Id(UUID: any, id: any) {
    return this.http.delete(`${this.API_BASE_PATH}${UUID}/business-ads/${id}`);
  }
}
